import {DealCategory} from "@irati/types"
import categoriesService from "../../services/dealCategory"

const isTagInCategory = (category: DealCategory, tagUuid: string) => {
  return category.tags.some((tag) => tag.uuid === tagUuid)
}

const getCategoryFromTag = (tagUuid: string): Promise<DealCategory> => {
  return categoriesService.listForCurrentPackage().then((categories) => {
    const dealCategory = categories.find((category) => isTagInCategory(category, tagUuid))!
    return dealCategory
  })
}

export default getCategoryFromTag
